var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"hidden-print btn",class:_vm.btnClass,on:{"click":_vm.print}},[_c('font-awesome-icon',{attrs:{"icon":_vm.faPrint}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }